module.exports = __webpack_public_path__ + "img/group_banner.b8b1a985.jpg";